import { useSelector } from "react-redux";

import { MakerIcon } from "@/assets/icons";
import EmptyPlaceholder from "@/components/emptyPlaceholder";
import { RootState } from "@/store";
import { geoJSONToWKT } from "@/utils/wkt";

export default function PolygonSelected() {
  const { polygonSettings } = useSelector((state: RootState) => state.spatial);

  return (
    <div>
      {Object.values(polygonSettings).length ? (
        <div className="flex flex-col gap-1 bg-white-smoke rounded-xl p-3">
          <p className="text-dim-gray text-xs">Polygon</p>
          <div className="max-h-[230px] overflow-auto">
            {Object.values(polygonSettings).map((polygon) => (
              <div className="flex flex-col" key={polygon.id}>
                <p className="text-txtHeading text-xs">{polygon.name}</p>
                <p className="text-dim-gray text-[10px] line-clamp-2">
                  {geoJSONToWKT(polygon.polygon.geometry)}
                </p>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <EmptyPlaceholder
          className="my-2 px-4 text-xs"
          icon={
            <MakerIcon className="fill-light-gray" width={21} height={26} />
          }
          description="You haven't drawn a custom polygon yet. Please create or select existing one."
        />
      )}
    </div>
  );
}
